import { isEmpty } from 'lodash';
import type { Values } from './types';

export const getValues = (values?: Values, defaultValues?: Values): Values =>
    (isEmpty(values) ? defaultValues : values) || {};
